module.exports = __webpack_public_path__ + "static/media/autopilot-mode-large.0345c966.png";